module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-4-edd5ba9a6703844be608c5acc3b61de5.png";